import React, { useContext } from 'react'
import LinePicker from '../Preview/components/LinePicker'
import Package from '../Preview/components/DesignPicker/Package'
import { getPackageName } from '../../helpers/packages'
import { formatPrice } from '../../helpers/price'
// Icons
import { ReactComponent as SparxLogo } from './icons/logo.svg'
import Disclaimer from '../Sidebar/components/Disclaimer'
import { useStore } from '../../store'
import { getPropertyName } from '../../helpers/property'
import { AppConfigContext } from '../../context/AppConfig'
import VariantWrapper from '../VariantWrapper'
import { variants } from '../../constants/variant'
import OfficesPropertyLogo from '../Preview/components/Offices/OfficesPropertyLogo'
import OfficesLinePicker from '../Preview/components/Offices/OfficesLinePicker'
function MobileSidebar({
  className = '',
  selectedPackage,
  selectedLevel,
  selectedLine,
  selectedPlan,
  property,
  onLineSelected,
  onFloorPlanSelected,
  packages = [],
  onPackageSelected,
}) {
  function isActive(pack) {
    return selectedPackage && pack.id === selectedPackage.id
  }

  const { data } = useStore()

  const { isSWApp, hide_vendor, isEWApp, isOfficesApp, show_package_price, hide_line, hide_prices, hide_disclaimer } = useContext(AppConfigContext)

  return (
    <div
      className={`w-[204px] shrink-0 bg-[#fff] h-full max-h-full py-[16px] px-[22px] flex-col overflow-y-auto justify-between ${className}`}
    >
      <div>
        <VariantWrapper hide={variants.of}>
          <div className="text-[14px] font-semibold">{getPropertyName(data?.property?.property_name)}</div>
        </VariantWrapper>
        <VariantWrapper show={variants.of}>
          <OfficesPropertyLogo />
        </VariantWrapper>
        <div className="my-[12px]">
          {!hide_line && <VariantWrapper hide={variants.of}>
            <LinePicker
              mobile
              onLineSelected={onLineSelected}
              onFloorPlanSelected={onFloorPlanSelected}
              selectedPlan={selectedPlan}
              selectedLine={selectedLine}
              property={property}
            />
          </VariantWrapper>}
          <VariantWrapper show={variants.of}>
            <OfficesLinePicker onLineSelected={onLineSelected} className="w-full" property={property} selectedLine={selectedLine} />
          </VariantWrapper>
        </div>
        <div>
          <div className="uppercase text-[12px] tracking-[1px] text-[#C7CCD9] font-bold">
            {isOfficesApp ? 'Configurations' : 'Packages'}
          </div>
          <div className="max-h-[190px] overflow-y-auto mt-[10px]">
            {packages.map((pack) => (
              <button
                key={pack.id}
                onClick={() => {
                  onPackageSelected(pack)
                }}
                type="button"
                className={`${
                  isOfficesApp ? 'h-[40px]' : 'h-[50px]'
                } w-full text-left font-medium mt-[10px] first:mt-[0] px-[12px] rounded-[6px] border-solid border-[#C7CCD9] border-[1px] ${
                  isActive(pack) ? 'bg-transparent' : 'bg-[#F5F5F5]'
                }`}
              >
                <div className={`${isActive(pack) ? '' : 'opacity-60'}`}>
                  <div className={`truncate ${isActive(pack) ? 'text-[var(--brand-color)]' : 'text-[#3D4256]'} ${hide_prices ? 'text-center' : 'text-left'}`}>
                    {getPackageName(pack)}
                  </div>
                  {!hide_prices && <VariantWrapper hide={variants.of}>
                    {!isEWApp && (
                      <div
                        className={`text-[12px] font-medium ${isSWApp ? 'opacity-60' : 'text-[#3D4256]'}  ${
                          isActive(pack) ? (isSWApp ? 'text-[var(--brand-color)] opacity-60' : '') : 'opacity-70'
                        } truncate`}
                      >
                        {isSWApp && !show_package_price
                          ? !hide_vendor ? `By ${pack.vendor.display_name}` : ''
                          : `${!show_package_price ? 'Starting at ' : ''}${formatPrice(pack.price)}/mo`}
                      </div>
                    )}
                  </VariantWrapper>}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between pt-[20px]">
        <div className="flex items-center">
          <div className="text-[10px] text-[#3D4256] opacity-60 mr-[4px]">Powered by</div>
          <SparxLogo />
        </div>
        {!hide_disclaimer && <Disclaimer btnClassName="!text-[10px] text-[#3D4256] opacity-60 font-medium" />}
      </div>
    </div>
  )
}

export default MobileSidebar
